import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatStepper } from '@angular/material/stepper'
import { Actions, ofType } from '@ngrx/effects'
import { select, Store } from '@ngrx/store'
import {
  ActivateHvmiListingSuccess,
  CreateHvmiListingSuccess,
  DeactivateHvmiListingSuccess,
  DeleteHvmiListingSuccess,
  DisconnectHvmiSuccess,
  GetHvmiListings,
  GetHvmiListingsSuccess,
  GetHvmiStatus,
  selectHvmiStatus,
  UpdateHvmiListingSuccess,
} from '@tokeet-frontend/channels'
import {
  Channel,
  DataCheckerService,
  Destroyable,
  LoadChannels,
  untilDestroy,
  UserStorage,
} from '@tokeet-frontend/tv3-platform'
import { LoadChannelPropertySettings } from '@tv3/store/channel-property-setting/channel-property-setting.actions'
import { LoadConnections } from '@tv3/store/connection/connection.actions'
import { delay, filter, switchMap, take } from 'rxjs/operators'

import { ChannelConnectHelperService } from '../channel-connect-helper.service'
import { LosDiscountGuard } from '@tokeet-frontend/los-discount'

@Component({
  selector: 'app-connect-hvmi-wizard',
  templateUrl: './connect-hvmi-wizard.component.html',
  styleUrls: ['./connect-hvmi-wizard.component.scss'],
  host: {
    class: 'modal-content',
  },
  providers: [ChannelConnectHelperService],
})
export class ConnectHvmiWizardComponent extends Destroyable implements OnInit, AfterViewInit {
  @ViewChild(MatStepper) stepper: MatStepper

  status$ = this.store.pipe(select(selectHvmiStatus))

  get channel() {
    return this.data.channel
  }

  constructor(
    public dialogRef: MatDialogRef<ConnectHvmiWizardComponent>,
    private actions: Actions,
    protected storage: UserStorage,
    private store: Store<any>,
    private channelConnectHelper: ChannelConnectHelperService,
    private dataChecker: DataCheckerService,
    @Inject(MAT_DIALOG_DATA) public data: { channel: Channel; isAdding: boolean }
  ) {
    super()
    this.dataChecker.check([LosDiscountGuard])
  }

  ngOnInit(): void {
    this.refresh()

    this.actions
      .pipe(
        ofType(
          DisconnectHvmiSuccess,
          GetHvmiListingsSuccess,
          CreateHvmiListingSuccess,
          ActivateHvmiListingSuccess,
          DeactivateHvmiListingSuccess,
          UpdateHvmiListingSuccess,
          DeleteHvmiListingSuccess
        ),
        untilDestroy(this)
      )
      .subscribe(() => {
        this.store.dispatch(LoadChannels())
        this.store.dispatch(LoadConnections({}))
        this.store.dispatch(LoadChannelPropertySettings())
      })

    this.channelConnectHelper.rentalImageCountsGuard().pipe(untilDestroy(this)).subscribe()
    this.actions.pipe(ofType(DisconnectHvmiSuccess), untilDestroy(this)).subscribe(() => {
      this.refresh()
    })
  }

  ngAfterViewInit(): void {
    this.stepper.animationDone
      .pipe(
        take(1),
        delay(500),
        switchMap(() => this.store.pipe(select(selectHvmiStatus))),
        filter((s) => !!s?.connected && !this.data.isAdding),
        take(1),
        untilDestroy(this)
      )
      .subscribe((status) => {
        this.stepper.selectedIndex = 1
      })
  }

  close() {
    this.dialogRef.close()
  }

  refresh() {
    this.store.dispatch(GetHvmiStatus())
    this.store.dispatch(GetHvmiListings())
  }
}
